import { Injectable } from '@angular/core';
import { MainService } from './main.service';

import { firstValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class InventoryService {

    constructor(
        private main: MainService
    ) { }

    getMaterialsCampaign(id_camp: number){
      return this.main.getRequest(`/inventory/materials_campaign/${id_camp}`);
    }
    getMaterialInfo(id: number, id_camp: number, id_mat: number, tipo: string){
      return this.main.getRequest(`/inventory/material_info/${id}/${id_camp}/${id_mat}/${tipo}`);
    }
    setInventario(data: any){
      return this.main.postRequest(data,"/inventory/save_inventory");
    }
    updateCantidadRecibida(data: any){
      return this.main.postRequest(data,"/inventory/update_cantidad_recibida");
    }
    getInventoryHistorial(id: number, tipo: string){
      return this.main.getRequest(`/inventory/inventario_historial/${id}/${tipo}`);
    }

    /** Pide un resumen del progreso de los productos en la campaña.
      * @param {number} id_camp El ID de la campaña a la que pertenecen los materiales.
      * @returns {Promise<Map<number, { rec: number, qty: number}>>} Un `Map` con las cantidades según el ID del material. */
    async getMaterialsSummary(id_camp: number): Promise<Map<number, { rec: number, qty: number}>> {
      const x: any = await firstValueFrom(this.main.getRequest(`/inventory/materials_summary/${id_camp}`));
      const summary: Map<number, { rec: number, qty: number}> = new Map<number, { rec: number, qty: number}>(x.data.map((i: any) => [i.id, { rec: i.recibido, qty: i.cantidad }]));
      return summary;
    }
}